import type { CSSProperties } from 'react';
import { useContext, useMemo } from 'react';
import { FileUploadsStateContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context';
import { HeaderHeight, ItemHeight, MaxBodyHeight, SidePadding } from '../consts';

export const useRootStyles = () => {
  const state = useContext(FileUploadsStateContext);

  const itemCount = useMemo(() => state.invalid.length + state.valid.length, [
    state.valid.length,
    state.invalid.length,
  ]);

  const styles: CSSProperties = useMemo(() => ({
    position: 'fixed',
    top: `calc(100vh - ${HeaderHeight}px - ${Math.min(itemCount * ItemHeight, MaxBodyHeight)}px - ${SidePadding}px)`,
    left: SidePadding,
  }), [itemCount]);

  return styles;
};